module.exports = __webpack_public_path__ + "assets/img/TechnicalBAIOS.9af348f3.png";